<template>
    <div class="deviceList">
        <div class="nav clearfix">
            <row>
                <van-col span="2">
                    <Icon name="arrow-left" size="26" />
                </van-col>
                <van-col span="18" align="center" justify="center" style="font-size:19px;">派工调度</van-col>
            </row>
        </div>
        <bottom />
    </div>
</template>

<script>
import { Icon, Button, Col, Row } from 'vant'
import bottom from '@/components/bottom'
export default {
    name: 'MaintainList',
    components: {
        bottom,
        Icon, [Button.name]: Button, [Col.name]: Col, Row
    },
    data() {
        return {
        }
    },
    methods: {
    }
}
</script>

